export const TOKEN_KEY = "StoreInfo";
export const FLAG_KEY = "FlagSelect"

export interface Store {
  store: String,
  flag: String,
  nameStore: String,
  index?: number
}

interface ISelectFlag {
  label: string,
  value: string
}

export const getStoreStorage = (): Store => {
  const json: any = localStorage.getItem(TOKEN_KEY);
  const obj: Store = JSON.parse(json);
  return obj || '';
};

export const setStoreStorage = (store: Store) => {
  let jsonAux: any = JSON.stringify(store);
  localStorage.setItem(TOKEN_KEY, jsonAux);
};

export const deleteStore = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const setSelectFlagStorage = (flag:ISelectFlag ) => {
  let jsonAux: any = JSON.stringify(flag);
  localStorage.setItem(FLAG_KEY, jsonAux);
}


export const getSelectFlagStorage = (): ISelectFlag => {
  const json: any = localStorage.getItem(FLAG_KEY);
  const obj: ISelectFlag = JSON.parse(json);
  return obj || {label: '', value: ''}
};
